// Personas – sync reconciliation constants.

import { z } from 'zod';

/**
 * Default number of consecutive complete syncs a personality key must be absent from
 * before reconciliation stales it.
 *
 * Upstream regenerates persona labels in cohorts under fresh ids, so a key missing from
 * one run is not evidence of deletion — 2026-08-08 returned 216 rows platform-wide
 * against 440 the day before and the sets recovered on their own. Three nightly runs is
 * the confirmation window (AD-2242).
 *
 * Shared because two independent callers must agree on it: `data-sync` reconciliation
 * and the `backfill-stale-personas` ops script both resolve the live threshold through
 * `DATA_SYNC_PERSONA_STALE_ABSENT_RUNS` (via `personaStaleAbsentRunsNexusDefaults`).
 * A script draining at a lower number than the pipeline confirms at would stale personas
 * the pipeline itself would have spared.
 */
export const PERSONA_STALE_ABSENT_RUNS_DEFAULT = 3;

/** Minimal NexusConfig slice — both data-sync and backfill-stale-personas read the same env key. */
export const personaStaleAbsentRunsNexusDefaults = {
  module: 'data-sync' as const,
  personaStaleAbsentRuns: PERSONA_STALE_ABSENT_RUNS_DEFAULT,
};

export const personaStaleAbsentRunsNexusSchema = z.object({
  module: z.literal('data-sync'),
  personaStaleAbsentRuns: z.number().int().min(1),
});
